module.exports = __webpack_public_path__ + "../static/img/fluxity_mini.1dccfa5d.png";